/*
 Массив образцов текста.
 Содержит несколько строк текста, которые могут быть случайно выбраны.
*/
const textSamples = [
	'Настала долгожданная золотая осень. Деревья раскрасились в разноцветные краски.На деревьях уютно сидят птички и поют прощальные песни перед отлетом в теплые края. Осень -это самое романтичное и чудесное время года.',
	'Сегодня за моим окном было очень красиво. Листья деревьев падали на лужи. Птицы сидели на деревьях и пели свои песни. Я люблю осеннее время года.',
	'Сегодня гуляя я увидела воробушка . У него маленькие лапки,красивый хвост, коричневато-серые перья. Воробушек клевал корочку хлеба .И он улетел из-за того- что прилетели голуби, я надеюсь он снова прилетит!',
]

/*
Функция для выбора случайного образца текста из массива.

Возвращает:
- Случайную строку текста из массива textSamples.
*/
const randomText = () => {
	// Выбираем случайный индекс в пределах длины массива textSamples.
	let text = textSamples[Math.floor(Math.random() * textSamples.length)]
	return text
}

// Экспортируем функцию для использования в других модулях.
export { randomText }
